import React from 'react';
import Loader from 'da-frontend-shared-ui-components/lib/Loader';

const CompactLoader = ({ children, style }: { children?: React.ReactNode, style?: React.CSSProperties }) => {
  return <div style={{ backgroundColor: "#ddd", width: "100%", height: 32, ...style }}>{children}</div>;
}

export default Loader;

export {
  CompactLoader
}